import React from "react";
import { Loader } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
function TreatmentsGridConsumer() {
  const {
    products,
    loading,
    error,
    refetch
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="28068" className="flex h-96 w-full items-center justify-center">
        <Loader className="h-8 w-8 animate-spin text-primary" />
      </div>;
  }
  if (error) {
    return <div className="flex h-64 w-full flex-col items-center justify-center gap-4 text-center">
        <p className="text-destructive">Failed to load digital assets.</p>
        <button onClick={refetch} className="text-foreground underline underline-offset-4 hover:text-primary transition-colors">
          Try Again
        </button>
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground font-default">No featured digital assets found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => {
      const hasDiscount = product.discounted_price !== undefined && product.discounted_price < product.price;
      const currentPrice = hasDiscount ? product.discounted_price : product.price;
      const isTenPercentOff = product.tags.some(tag => tag.name.includes("10%")) || hasDiscount;
      return <Card key={product.id} data-index={i} className="group relative flex flex-col overflow-hidden rounded-sm border border-border bg-card/40 backdrop-blur-md shadow-sm transition-all hover:shadow-primary/10 hover:border-primary/50">
            {}
            {isTenPercentOff && <Badge variant="default" className="absolute top-3 right-3 z-10 rounded-sm bg-primary px-2 py-1 text-[10px] font-bold tracking-widest text-primary-foreground uppercase hover:bg-primary">
                PROMO
              </Badge>}

            {}
            <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted/20">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/10 text-muted-foreground">
                  <span className="text-xs font-mono">NO_IMAGE</span>
                </div>}

              {}
              <div className="absolute inset-x-0 bottom-0 p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <AddToCartButton productId={product.id} variant="default" text="Add to Cart" className="w-full" buttonClassName="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm font-bold uppercase tracking-wider text-xs h-10 transition-all" showQuantity={false} />
              </div>
            </div>

            {}
            <CardContent className="flex flex-col gap-1 p-4 pt-5">
              <Link to={product.link} className="group-hover:text-primary transition-colors">
                <h3 className="line-clamp-1 font-default text-sm font-bold text-foreground uppercase tracking-wider">
                  {product.title}
                </h3>
              </Link>

              <div className="flex items-baseline gap-2 font-mono">
                {hasDiscount && <span className="text-xs font-medium text-muted-foreground line-through">
                    ${product.price.toFixed(2)}
                  </span>}
                <span className="text-sm font-bold text-foreground">
                  ${(currentPrice || 0).toFixed(2)}
                </span>
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function SignatureTreatments() {
  return <section id="featured-digital-assets" className="flex w-full flex-col dark bg-background text-foreground">
      {}
      <div className="w-full bg-card/30 border-b border-border py-16 text-center">
        <div className="container mx-auto px-4">
          <h2 className="font-default text-3xl font-bold text-foreground uppercase tracking-widest sm:text-4xl">
            Featured Assets
          </h2>
        </div>
      </div>

      {}
      <div className="w-full bg-background py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <EcommerceProductsProvider wp_query={{
          per_page: 4,
          orderby: "date",
          order: "desc"
        }} postType="product" className="w-full">
            <TreatmentsGridConsumer />
          </EcommerceProductsProvider>
        </div>
      </div>
    </section>;
}